"use strict";
var Observable_1 = require('../../Observable');
var of_1 = require('../../observable/of');
Observable_1.Observable.of = of_1.of;
//# sourceMappingURL=of.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/observable/of.js
// module id = 171
// module chunks = 3